import { render, staticRenderFns } from "./SoftwareService.vue?vue&type=template&id=3560e200&"
import script from "./SoftwareService.vue?vue&type=script&lang=js&"
export * from "./SoftwareService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports